import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { MONTHS_WITHOUT_ALL } from '../../../../utils/courseIncome/constaints';
import { attendanceViewCroTableHead } from './utils/tableHeaders';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import DailyView from './components/DailyView';
import { getAttendanceView } from '../../../../redux/features/crdMigrationSlice';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';

export default function AttendanceViewCro() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  const loading = useSelector((state) => state.crdMigration.attendanceViewTable.loading);
  const attendanceViewTable = useSelector((state) => state.crdMigration.attendanceViewTable.data);

  //--------------------------------------------------------------------------

  // react state
  const [month, setMonth] = useState({ id: dayjs().month() + 1, value: '' });
  const [year, setYear] = useState(dayjs().year());

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      year,
      month: month?.id,
    }),
    [year, month],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getAttendanceView(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  // table Head
  const tableHead = useMemo(() => attendanceViewCroTableHead({ setModalState, month }), [month]);

  // Global_Dialogue --------------------------------------------------------

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'Daily View',
        title: 'Daily View',
        maxWidth: 'lg',
        render: ({ row }) => <DailyView row={row} yearAndMonth={`${year}-${String(month?.id).padStart(2, '0')}`} />,
      },
    ],
    [year, month],
  );

  const activeConfig = useMemo(() => {
    if (!modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  // ---------------------------------------------------

  return (
    <GlobalWrapper title={'Attandance View'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <GlobalSelectFieldWithoutFormikNew
            data={MONTHS_WITHOUT_ALL}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            label={'Months'}
            selectedDetails={month}
            setChange={setMonth}
            sx={{
              maxWidth: { xs: '100%', sm: 180 },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={'Year'}
              views={['year']}
              onChange={(v) => setYear(v?.year() ? v?.year() : dayjs().year())}
              value={dayjs().year(year)}
              sx={{
                maxWidth: { xs: '100%', sm: 180 },
              }}
            />
          </LocalizationProvider>
        </Stack>
        <GlobalTableNoPagination
          rowUniqueId="sl_no"
          headers={tableHead}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={attendanceViewTable}
          onButtonActionClick={handleButtonActionClick}
        />
        <GlobalDialog
          title={activeConfig?.title}
          open={Boolean(modalState?.actionKey)}
          setOpen={(val) => {
            if (!val) setModalState({ actionKey: '', row: null });
          }}
          closeButton={true}
          content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
          maxWidth={activeConfig?.maxWidth || 'md'}
          fullWidth={true}
        />
      </Stack>
    </GlobalWrapper>
  );
}
